import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose, withApollo } from 'react-apollo';
import Form from './Form';

import { withFormik } from 'formik';
import { formikConfig } from './formikConfig';
import withClaimQuery from '../HOC/withClaimQuery';

class ClaimFormContainer extends React.Component {
  state = {};

  handleChange = (e, { name, value }) => this.props.setFieldValue(name, value);

  handleTimeChange = (field, value) => this.props.setFieldValue(field, value);

  handleBlur = name => this.props.setFieldTouched(name, true);

  handleCancel = () => this.props.history.goBack();

  handleDataSubmit = e => this.props.handleSubmit(e);

  handleClaimUpdated = () => this.props.refetch();

  hideLoading = () => this.setState({ loading: false });

  showLoading = () => this.setState({ loading: true });

  render = () => {
    const { isSubmitting, loading,  ...restProps } = this.props;
    return (
      <Form
        ref="claimFormRef"
        {...restProps}
        onTimeChange={this.handleTimeChange}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onCancel={this.handleCancel}
        onSubmit={this.handleDataSubmit}
        isSubmitting={isSubmitting}
        loading={loading || this.state.loading || isSubmitting}
        onClaimUpdated={this.handleClaimUpdated}
        hideLoading={this.hideLoading}
        showLoading={this.showLoading}
      />
    );
  };
}

export default compose(
  withRouter,
  withApollo,
  withClaimQuery,
  withFormik(formikConfig)
)(ClaimFormContainer);



// WEBPACK FOOTER //
// ./src/component/ClaimForm/index.js